import { GetAccountNumbersResponseDto } from "@common/dto/financialAccount/get-account-numbers-response.dto";
import { FinancialAccount } from "@common/types/financialAccount";
import { FinancialAccountDto } from "@common/dto/financialAccount/financial-account.dto";
import { GetDocumentsForFinancialAccountResponseDto } from "@common/dto/financialAccount/get-documents-for-financial-account-response.dto";
import { FinancialDocumentDto } from "@common/dto/financialDocument/financial-document.dto";
import { MergeFinancialAccountsDto } from "@common/dto/financialAccount/mergeFinancialAccounts/merge-financial-accounts.dto";
import { MergeFinancialAccountsResponseDto } from "@common/dto/financialAccount/mergeFinancialAccounts/merge-financial-accounts-response.dto";
import { backendClient, unwrapResponse } from "./backendClient";

export interface ExtendedFinancialAccount extends FinancialAccount {
    accountNumber?: string;
}

export async function disableFinancialAccount(
    accountId: number,
): Promise<FinancialAccount> {
    return FinancialAccountDto.deserialize(
        unwrapResponse(
            await backendClient.post<FinancialAccountDto>(
                `/financial-account/${accountId}/disable`,
            ),
        ),
    );
}

export async function enableFinancialAccount(
    accountId: number,
): Promise<FinancialAccount> {
    return FinancialAccountDto.deserialize(
        unwrapResponse(
            await backendClient.post<FinancialAccountDto>(
                `/financial-account/${accountId}/enable`,
            ),
        ),
    );
}

export async function getFinancialAccountNumbers(): Promise<GetAccountNumbersResponseDto> {
    return await unwrapResponse(
        await backendClient.get("/financial-account/account-numbers"),
    );
}

export async function getUnassignedFinancialAccounts(): Promise<
    FinancialAccount[]
> {
    return (
        await backendClient.get<FinancialAccountDto[]>(
            "/financial-account/unassigned",
        )
    ).data.map((account) => FinancialAccountDto.deserialize(account));
}

export async function getDocumentsForFinancialAccount(accountId: number) {
    const response: GetDocumentsForFinancialAccountResponseDto = unwrapResponse(
        await backendClient.get(
            `/financial-account/${accountId}/financial-documents`,
        ),
    );

    return response.data.map(FinancialDocumentDto.deserialize);
}

export async function mergeFinancialAccounts(data: MergeFinancialAccountsDto) {
    const response = unwrapResponse(
        await backendClient.post<MergeFinancialAccountsResponseDto>(
            "/financial-account/merge",
            data,
        ),
    );

    return MergeFinancialAccountsResponseDto.deserialize(response);
}
